import type { ConfigProviderThemeVars } from 'wot-design-uni'
import { ref } from 'vue'

const theme = ref<'light' | 'dark'>('light')

const baseVars: ConfigProviderThemeVars = {
  swiperRadius: '0',
}
const themeVars = ref<ConfigProviderThemeVars>(baseVars)
// 默认主题
const defaultTheme = {
  ...baseVars,
  colorTheme: '#ff6600',
  buttonPrimaryBgColor: '#ff6600',
  swiperRadius: '0',
  cellWrapperPadding: '1rem',
}

// 租房管理主题
const rentalTheme = {
  ...baseVars,
  colorTheme: '#4080ff',
}

export function useTheme(vars?: ConfigProviderThemeVars) {
  vars && (themeVars.value = vars)

  function toggleTheme(mode?: 'light' | 'dark') {
    theme.value = mode || (theme.value === 'light' ? 'dark' : 'light')
  }
  function switchTheme(mode = 'default') {
    switch (mode) {
      case 'rentalManage':
        themeVars.value = rentalTheme
        break
      case 'default':
        themeVars.value = defaultTheme
        break
      default:
        themeVars.value = defaultTheme
        break
    }
  }

  return {
    theme,
    themeVars,
    toggleTheme,
    switchTheme,
    rentalTheme,
    defaultTheme,
  }
}
